import request from '@/common/request'
import file from '@/common/fileDownload'

export default {
  operationManualExportPDF: params =>{
    file.fileDownload('/file/智能锁管理平台用户手册.pdf', params);
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/ecHeaderDownload.js